<div class="banner" *ngIf="actived">
    <p>
        <ng-container *ngIf="isNewInstructions; else oldInstructions">
            Estás probando las nuevas instrucciones (versión beta). 
            Si prefieres, puedes 
            <span (click)="navigateOtherInstructions()" class="link">
                volver a la versión anterior
            </span> 
            en cualquier momento.
        </ng-container>
        <ng-template #oldInstructions>
            ¡Tenemos nuevas instrucciones disponibles! 
            Si quieres, puedes 
            <span (click)="navigateOtherInstructions()" class="link">
                probar la nueva versión
            </span> 
            en cualquier momento.
        </ng-template>
    </p>
</div>
